export const VENDORLINK_GETDATA_LOADING = 'VENDORLINK_GETDATA_LOADING';
export const VENDORLINK_GETDATA_ERROR = 'VENDORLINK_GETDATA_ERROR';

// Configuration
export const VENDORLINK_GETCONFIGURATION_LOADING =
  'VENDORLINK_GETCONFIGURATION_LOADING';
export const VENDORLINK_GETCONFIGURATION_SUCCESS =
  'VENDORLINK_GETCONFIGURATION_SUCCESS';
export const VENDORLINK_GETCONFIGURATION_ERROR =
  'VENDORLINK_GETCONFIGURATION_ERROR';

export const VENDORLINK_POSTGETLEAINFOREFIDS_LOADING =
  'VENDORLINK_POSTGETLEAINFOREFIDS_LOADING';
export const VENDORLINK_POSTGETLEAINFOREFIDS_SUCCESS =
  'VENDORLINK_POSTGETLEAINFOREFIDS_SUCCESS';
export const VENDORLINK_POSTGETLEAINFOREFIDS_ERROR =
  'VENDORLINK_POSTGETLEAINFOREFIDS_ERROR';

export const VENDORLINK_POSTTESTCONNECTION_LOADING =
  'VENDORLINK_POSTTESTCONNECTION_LOADING';
export const VENDORLINK_POSTTESTCONNECTION_SUCCESS =
  'VENDORLINK_POSTTESTCONNECTION_SUCCESS';
export const VENDORLINK_POSTTESTCONNECTION_ERROR =
  'VENDORLINK_POSTTESTCONNECTION_ERROR';

export const VENDORLINK_SETCONFIGURATION_LOADING =
  'VENDORLINK_SETCONFIGURATION_LOADING';
export const VENDORLINK_SETCONFIGURATION_SUCCESS =
  'VENDORLINK_SETCONFIGURATION_SUCCESS';
export const VENDORLINK_SETCONFIGURATION_ERROR =
  'VENDORLINK_SETCONFIGURATION_ERROR';

// Mapping
export const VENDORLINK_GETMAPPINGS_LOADING = 'VENDORLINK_GETMAPPINGS_LOADING';
export const VENDORLINK_GETMAPPINGS_SUCCESS = 'VENDORLINK_GETMAPPINGS_SUCCESS';
export const VENDORLINK_GETMAPPINGS_ERROR = 'VENDORLINK_GETMAPPINGS_ERROR';

export const VENDORLINK_GETSITES_LOADING = 'VENDORLINK_GETSITES_LOADING';
export const VENDORLINK_GETSITES_SUCCESS = 'VENDORLINK_GETSITES_SUCCESS';
export const VENDORLINK_GETSITES_ERROR = 'VENDORLINK_GETSITES_ERROR';

export const VENDORLINK_GETGRADES_LOADING = 'VENDORLINK_GETGRADES_LOADING';
export const VENDORLINK_GETGRADES_SUCCESS = 'VENDORLINK_GETGRADES_SUCCESS';
export const VENDORLINK_GETGRADES_ERROR = 'VENDORLINK_GETGRADES_ERROR';

export const VENDORLINK_SETMAPPINGS_LOADING = 'VENDORLINK_SETMAPPINGS_LOADING';
export const VENDORLINK_SETMAPPINGS_SUCCESS = 'VENDORLINK_SETMAPPINGS_SUCCESS';
export const VENDORLINK_SETMAPPINGS_ERROR = 'VENDORLINK_SETMAPPINGS_ERROR';

// Preview
export const VENDORLINK_PREVIEW_CLEAR_ERRORS =
  'VENDORLINK_PREVIEW_CLEAR_ERRORS';
export const VENDORLINK_PREVIEW_CLEAR_SUCCESS =
  'VENDORLINK_PREVIEW_CLEAR_SUCCESS';
export const VENDORLINK_PREVIEW_UPDATE_SUCCESS =
  'VENDORLINK_PREVIEW_UPDATE_SUCCESS';
export const VENDORLINK_PREVIEW_RAN = 'VENDORLINK_PREVIEW_RAN';
export const VENDORLINK_PREVIEW_ERROR = 'VENDORLINK_PREVIEW_ERROR';
export const VENDORLINK_PREVIEW_SET_ID = 'VENDORLINK_PREVIEW_SET_ID';
export const VENDORLINK_PREVIEW_LOADING = 'VENDORLINK_PREVIEW_LOADING';
export const VENDORLINK_PREVIEW_SUCCESS = 'VENDORLINK_PREVIEW_SUCCESS';
export const VENDORLINK_PREVIEW_CLEAR_DATA = 'VENDORLINK_PREVIEW_CLEAR_DATA';

// Single Student Import
export const VENDORLINK_IMPORT_STUDENT_LOADING =
  'VENDORLINK_IMPORT_STUDENT_LOADING';
export const VENDORLINK_IMPORT_STUDENT_SUCCESS =
  'VENDORLINK_IMPORT_STUDENT_SUCCESS';
export const VENDORLINK_IMPORT_STUDENT_ERROR =
  'VENDORLINK_IMPORT_STUDENT_ERROR';
export const VENDORLINK_IMPORT_STUDENT_CLEAR_ERROR =
  'VENDORLINK_IMPORT_STUDENT_CLEAR_ERROR';
export const VENDORLINK_IMPORT_STUDENT_SET_SUCCESS =
  'VENDORLINK_IMPORT_STUDENT_SET_SUCCESS';

// Bulk Import
export const VENDORLINK_BULK_IMPORT_LOADING = 'VENDORLINK_BULK_IMPORT_LOADING';
export const VENDORLINK_BULK_IMPORT_ERRORS = 'VENDORLINK_BULK_IMPORT_ERRORS';
export const VENDORLINK_BULK_IMPORT_COMPLETE =
  'VENDORLINK_BULK_IMPORT_COMPLETE';



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/state/types.js